<template>
  <div class="lg:px-8 md:px-5 px-2 lg:py-10 md:py-6 py-5 bg-fa">
    <el-dialog
      :visible.sync="addDetailModal"
      :show-close="false"
      width="500px"
      hide-header
      :center="true"
    >
      <template #header></template>
      <h3 class="text-lg font-semibold text-gray-800 mb-4 text-center">
        Looks like you’re not signed in. <br />Could you please fill in the
        details below?
      </h3>
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(validateModalData)">
          <div>
            <p class="font-semibold text-sm mb-2">Email</p>
            <base-input
              v-model="guestEmail"
              name="Email"
              placeholder="Enter your email id"
              :rules="{ required: true, email: true }"
              class="cust-form-border"
            />
          </div>
          <div class="my-4">
            <p class="font-semibold text-sm mb-2">Mobile no.</p>
            <base-input
              v-model="guestMobile"
              name="mobile"
              placeholder="Enter your mobile no."
              :rules="{ numeric: true, required: true, min: 10, max: 10 }"
              class="cust-form-border"
            />
          </div>
          <div slot="footer" class="dialog-footer">
            <base-button type="primary" native-type="submit"
              >Submit</base-button
            >
            <base-button type="secondary" @click="addDetailModal = false"
              >Close</base-button
            >
          </div>
        </b-form>
      </validation-observer>
    </el-dialog>
    <div class="container mx-auto">
      <div class="mx-auto text-center">
        <h2 class="text4F0A4B fsize32 sm-fsize24 mb-2 lg:mx-10 mx-2">
          Your input helps us serve you better. What more <br />
          would you like to learn?
        </h2>
      </div>
      <div class="flex justify-center">
        <div class="lg:w-1/2 md:w-7/12 w-full mx-auto flex flex-col">
          <!-- <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
            <b-form role="form"  @submit.prevent="handleSubmit(submitForm)"> -->
          <el-input
            class="w-full bdr8px-ip ip-focus-none mt-5"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 5 }"
            placeholder="Write your thought..."
            v-model="textarea1"
            :rules="{ required: true }"
          >
          </el-input>
          <base-button
            native-type="submit"
            type="primary"
            @click="submitForm()"
            class="w-32 mx-auto mt-3"
            :disabled="!textarea1"
            >Submit</base-button
          >
          <!-- </b-form>
          </validation-observer> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      textarea1: "",
      guestEmail: "",
      guestMobile: "",
      addDetailModal: false,
    };
  },
  methods: {
    validateModalData() {
      if (this.guestEmail && this.guestMobile) {
        this.addDetailModal = false;
        this.submitForm();
      }
    },
    async submitForm() {
      if (Object.keys(this.user).length === 0) {
        if (!this.guestEmail || !this.guestMobile) {
          this.addDetailModal = true;
          return;
        }
      } else {
        this.guestEmail = this.user.email;
        this.guestMobile = this.user.mobile;
      }

      // if (!this.guestEmail || !this.guestMobile) {
      //   this.addDetailModal = true;
      //   return;
      // }

      const payload = {
        text: this.textarea1,
        email: this.guestEmail,
        mobile: this.guestMobile,
      };

      if (this.$route.name === "medical_cancer") {
        payload.category = "Cancer";
      } else if (this.$route.name === "medical_palliative") {
        payload.category = "Palliative";
      } else if (this.$route.name === "medical_dementia") {
        payload.category = "Dementia";
      } else if (this.$route.name === "medical_neurologicaldisorders") {
        payload.category = "Neurological Disorders";
      }

      console.log("payload", payload);
      try {
        await this.$store.dispatch("newsletter/medicalThoughts", payload);
        this.$swal
          .fire({
            text: "Thank you for your thoughts",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          })
          .then(() => {
            this.textarea1 = "";
            this.guestEmail = "";
            this.guestMobile = "";
            this.addDetailModal = false;
          });
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
};
</script>
<style>
.bdr8px-ip > .el-textarea__inner {
  border-radius: 8px !important;
}
.el-textarea__inner:focus {
  border-color: #dcdfe6 !important;
  outline: 0;
}
.el-dialog__header {
  padding: 0;
}
</style>
